// extracted by mini-css-extract-plugin
module.exports = {"cell":"table-row_cell__1R04r","date":"table-row_date__yuau-","btn":"table-row_btn__1oKwz"};